<cmi-back-button />

<div class="flex items-center justify-between mb-2 w-full border-b border-gray-300 pb-2">
  <h2 class="text-lg font-semibold">
    {{ 'reports.title' | translate }}
  </h2>
  @if (externalLink()) {
    <button
      type="button"
      (click)="onOpenExternalLink()"
      class="text-gray-500 hover:text-main transition-colors"
      [title]="'reports.openExternal' | translate">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="size-5">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
      </svg>
    </button>
  }
</div>

<div class="flex flex-col gap-4 mt-4">
  <div>
    <label for="reports-input" class="block text-sm/6 font-medium text-gray-700">
      {{ 'reports.inputLabel' | translate }}
    </label>
    <div class="mt-1">
      <div
        class="flex items-center rounded-md bg-white pl-3 outline-1 -outline-offset-1 outline-gray-300 focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-main">
        <input
          type="text"
          id="reports-input"
          [value]="value()"
          (input)="onInput($event)"
          class="block min-w-0 grow bg-transparent py-1.5 pr-3 pl-1 text-base text-gray-900 placeholder:text-gray-500 focus:outline-none sm:text-sm/6" />
      </div>
    </div>
  </div>

  @if (selectorProvidersSupported()) {
    <div>
      <label for="reports-selector-provider" class="block text-sm/6 font-medium text-gray-700">
        {{ 'reports.selectorProvider' | translate }}
      </label>
      <div class="mt-1">
        @if (selectorProvidersLoading()) {
          <div class="flex items-center justify-center py-2">
            <cmi-loading-spinner />
          </div>
        } @else if (selectorProvidersError()) {
          <cmi-notification
            mode="error"
            [message]="'common.notifications.errorTitle' | translate"
            [description]="'common.notifications.loadingFailed' | translate"
            [actionLabel]="'common.notifications.retry' | translate"
            (action)="reloadSelectorProviders()" />
        } @else {
          <div
            class="relative flex items-center rounded-md bg-white outline-1 -outline-offset-1 outline-gray-300 focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-main">
            <select
              id="reports-selector-provider"
              (change)="onProviderChange($event)"
              class="w-full appearance-none bg-transparent py-1.5 pl-3 pr-8 text-base text-gray-900 focus:outline-none sm:text-sm/6">
              <option value="" [selected]="selectedProvider() === ''">
                {{ 'reports.selectorProviderPlaceholder' | translate }}
              </option>
              @for (provider of selectorProviders(); track provider.key) {
                <option [value]="provider.key" [selected]="provider.key === selectedProvider()">
                  {{ provider.displayName }}
                </option>
              }
            </select>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="pointer-events-none absolute right-2 size-4 text-gray-500">
              <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
            </svg>
          </div>
        }
      </div>
    </div>
  }

  <div class="flex justify-start">
    <cmi-button
      [label]="'reports.save' | translate"
      [loading]="isSaving()"
      [disabled]="!value() || isSaving()"
      (clicked)="onSave()" />
  </div>

  @if (duplicateError()) {
    <cmi-notification mode="error" [message]="'reports.duplicateError' | translate" />
  }
  @if (saveSuccess()) {
    <cmi-notification mode="success" [message]="'reports.saveSuccess' | translate" />
  }
  @if (saveError()) {
    <cmi-notification mode="error" [message]="'reports.saveError' | translate" />
  }
</div>
